import DisparosContainer from "@/components/consignado/NotificacoesConfigRedesign/DisparosContainer";

// Tela "Config. Notificações" — cadastro de disparos
// (HIS-APP-notificacoes-007, consignado-trabalhador). O container faz as
// chamadas: catálogo, grade paginada, detalhe por id e as escritas com
// controle de versão.
//
// A 007 é só cadastro — nenhuma ação daqui envia notificação.
export default function ConfigNotificacoesPage() {
  return <DisparosContainer />;
}
